import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { LOCATION, PHONE } from "../../../assets/icons";
import {
  CustomButton,
  CustomLoader,
  FormModalTitle,
  SvgContainer,
} from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import { User } from "../../../store/features/authSlice";
import { createAsyncBoss } from "../../../store/features/bossSlice";
import theme from "../../../theme/theme";
import notifyMessage from "../../../utils/notify";
import { capitalizeFirstLetter } from "../../../utils/strings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 400, md: 550, lg: 550 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  padding: 3,
};

interface Props {
  open: boolean;
  onClose(): void;
}

function BossForm({ open, onClose }: Props) {
  const [formData, setFormData] = useState<User>({
    nom: "",
    prenom: "",
    email: "",
    telephone: "+225",
    adresse: "",
    codeParrainage: "",
    connuJeVeBara: "BOUCHE_A_OREILLE",
    signature: "",
    pin: "0000",
  });
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onChangeField = (key: string, value: string) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleClose = () => {
    onClose();
  };

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const callback = () => {
    setLoading(false);
    handleClose();
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("create_success")),
      severity: "success",
    });
  };

  const onError = () => {
    setLoading(false);
    notifyMessage({
      message: capitalizeFirstLetter(i18n.t("error_occured")),
      severity: "error",
    });
  };

  const onSubmit = () => {
    toggleLoader();
    dispatch(createAsyncBoss(formData, callback, onError) as any);
  };

  const disabled =
    !formData.nom.trim() ||
    !formData.telephone.trim() ||
    !formData.adresse.trim();

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t("ajouter_un_boss")}
            onClose={handleClose}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("nom"))}
            value={formData.nom}
            onChange={(value: string) => onChangeField("nom", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("prenom"))}
            value={formData.prenom}
            onChange={(value: string) => onChangeField("prenom", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("email"))}
            value={formData.email}
            onChange={(value: string) => onChangeField("email", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("telephone"))}
            value={formData.telephone}
            icon={
              <Box mt={0.5}>
                <SvgContainer
                  svg={PHONE}
                  width={15}
                  color={theme.colors.dimgray + "80"}
                />
              </Box>
            }
            onChange={(value: string) => onChangeField("telephone", value.replace(/[^+0-9]/g, ""))}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("localisation"))}
            value={formData.adresse}
            icon={
              <Box>
                <SvgContainer
                  svg={LOCATION}
                  width={15}
                  color={theme.colors.dimgray + "80"}
                />
              </Box>
            }
            onChange={(value: string) => onChangeField("adresse", value)}
          />
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("ajouter_boss"))}
            onClick={onSubmit}
            disabled={disabled}
            rootStyle={{
              width: "100%",
              height: 50,
              marginTop: 3,
              marginBottom: 2,
              backgroundColor: disabled
                ? theme.colors.disabled
                : theme.colors.primary,
            }}
            titleStyle={{ color: theme.colors.white }}
          />
        </Box>
        <CustomLoader open={loading} handleClose={toggleLoader} />
      </form>
    </Modal>
  );
}

export default BossForm;
